import React, { useMemo } from "react";
import styles from "./PlacementEfficiency.module.css";

const PlacementEfficiency = ({
  transittimedata = [],
  selectedTransporterId,
}) => {
  if (!transittimedata.length) return <div>No Data</div>;

  const tableData = useMemo(() => {
    if (!selectedTransporterId) return [];

    return transittimedata
      .flatMap((lane) => lane.indent_breakdown || [])
      .filter((item) => item.transporter_id === selectedTransporterId);
  }, [transittimedata, selectedTransporterId]);

  const totals = useMemo(() => {
    return tableData.reduce(
      (acc, item) => {
        acc.allocated += item.allocated || 0;
        acc.placed += item.placed || 0;
        return acc;
      },
      { allocated: 0, placed: 0 },
    );
  }, [tableData]);

  return (
    <div className={styles.tableWrapperTransit}>
      {/* HEADER */}
      <div className={styles.summaryHeader}>
        <div className={styles.routeInfo}>
          <div>
            <span>
              <strong>Total Trucks Allocated:</strong> {totals.allocated}
            </span>
            <span style={{ marginLeft: "20px" }}>
              <strong>Total Trucks Placed:</strong> {totals.placed}
            </span>
          </div>
        </div>
      </div>

      {/* TABLE */}
      {tableData.length > 0 && (
        <div className={styles.tableContainer}>
          <table className={styles.transitTable}>
            <thead>
              <tr>
                <th>#</th>
                <th>Indent ID</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Allocated</th>
                <th>Placed</th>
                <th>Pending</th>
                {/* <th>Efficiency (%)</th> */}
              </tr>
            </thead>

            <tbody>
              {tableData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className={styles.indentId}>{item.indent_id || "-"}</td>
                  <td>{item.origin || "-"}</td>
                  <td>{item.destination || "-"}</td>
                  <td>{item.allocated}</td>
                  <td>{item.placed}</td>
                  <td>{item.pending}</td>
                  {/* <td>{item.placement_efficiency}%</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PlacementEfficiency;
